import { Fragment, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import CallDialed from "./components/CallDailed";
import { useSdk } from "./hooks/usesdk";
import { IsJsonString } from "./utils/isJsonString";
import { login } from "./store/features/auth/authSlice";
import { setMakeCallData } from "./store/features/dialer/activeCollapseSlice";
import { CALL_STATE } from "./utils/constants";
import { setOngoingCallTime } from "./store/features/dialer/callStatusSlice";

const Init = () => {
  const [voipToken, setVoipToken] = useState([]);
  const [providers, setProviders] = useState([]);
  const dispatch = useDispatch();
  const { callState } = useSelector(
    (state: {
      device: {
        activeCallData: { from: string };
        callState: any;
        isIncoming: boolean;
        isOnCall: boolean;
        acceptIncomingCallStatus: any;
      };
    }) => state?.device
  );

  const hasTimeStarted = useMemo(() => {
    return (
      callState === CALL_STATE.ACTIVE ||
      callState === CALL_STATE.CONNECTING ||
      callState === CALL_STATE.ACCEPTED ||
      callState === CALL_STATE.HELD
    );
  }, [callState]);
  useEffect(() => {
    const handleMessage = (event: any) => {
      if (event?.data?.action === "CALL_STARTED") {
        const tokens = IsJsonString(event?.data?.tokens)
          ? JSON.parse(event?.data?.tokens)
          : {};
        const callInfo = IsJsonString(event?.data?.number)
          ? JSON.parse(event?.data?.number)
          : {};
        const newProviders = IsJsonString(event?.data?.providers)
          ? JSON.parse(event?.data?.providers)
          : [];
        const newVoipTokens = IsJsonString(event?.data?.voip)
          ? JSON.parse(event?.data?.voip)
          : [];

        dispatch(login(tokens));
        dispatch(setMakeCallData(callInfo));

        // Only update local state if the new data is different
        setVoipToken((prev) =>
          JSON.stringify(prev) !== JSON.stringify(newVoipTokens)
            ? newVoipTokens
            : prev
        );
        setProviders((prev) =>
          JSON.stringify(prev) !== JSON.stringify(newProviders)
            ? newProviders
            : prev
        );
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [dispatch]);

  const { callPocket } = useSdk({ token: voipToken });

  // Memoize callPocket calls
  const callPocketComponents = useMemo(() => {
    if (!voipToken?.length || !providers?.length) return null;
    return voipToken.map((voip: { provider: string }) => (
      <Fragment key={voip.provider}>{callPocket(voip.provider)}</Fragment>
    ));
  }, [voipToken, providers, callPocket]);

  useEffect(() => {
    if (hasTimeStarted) {
      const interval = setInterval(() => {
        dispatch(setOngoingCallTime(""));
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [hasTimeStarted]);

  return (
    <>
      <div style={{ position: "absolute" }}>{callPocketComponents}</div>
      <CallDialed />
    </>
  );
};

export default Init;
